import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {BookOpen, Home} from "lucide-react";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const AboutCommunitySheet = styled(({className, community}) => {
    const history = useHistory();
    const handleAbout = () => {
        history.push(`/c/${community}/about`);
    };
    const handleWiki = () => {
        history.push(`/c/${community}/wiki`);
    };
    return (
        <div className={className}>
            <MenuItem onClick={handleAbout}>
                <MenuItemIcon>
                    <Home size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    About
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleWiki}>
                <MenuItemIcon>
                    <BookOpen size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Wiki
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default AboutCommunitySheet;
